



















































































import { computed, PropType, toRef } from 'vue';
import { mediaTypes } from '../../enums/mediaTypes';
import { conversionStatusTypes } from '../../enums/conversionStatusTypes';
import { parentTypes } from '../../enums/parentTypes';

import AulaCard from '../../components/AulaCard.vue';
import { MediaModel } from '../../models/media.model';
import Icon from '../../components/Icon.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';
import VideoThumbnail from './VideoThumbnail.vue';
import AulaButton from '../../components/AulaButton.vue';
import SoundThumbnail from './SoundThumbnail.vue';
import ImageThumbnail from './ImageThumbnail.vue';
import { useMediaScan } from '../../composables/useMediaScan';
import Button from '../../directives/button.js';
import { ScanningStatusEnum } from '../../enums/scanningStatus.enum';

export default {
  name: 'MediaCard',
  components: { ImageThumbnail, SoundThumbnail, AulaButton, VideoThumbnail, Icon, AulaCard },
  directives: { Button },
  props: {
    media: { type: Object as PropType<MediaModel>, required: true },
    showSelectBox: { type: Boolean, default: false },
    canDeleteMedia: { type: Boolean, default: false },
    showDeleteMedia: { type: Boolean, default: true },
    isNew: { type: Boolean, default: false },
  },
  emits: ['onDeleteMediaClick', 'click'],
  setup(props, { emit }) {
    const media = toRef(props, 'media');
    const { scanningText, isMediaDisabled } = useMediaScan(media);
    const isDisabledClick = computed(() => isMediaDisabled.value && !props.showSelectBox);

    const isChecked = computed(() => props.media.selected);

    const mediaIndicatorId = computed(() => `media-${props.media.id}-indicator`);

    const handleClick = (event: MouseEvent) => {
      if (isDisabledClick.value) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      emit('click', event);
    };

    const onDeleteMediaClick = () => {
      emit('onDeleteMediaClick');
    };

    return {
      conversionStatusTypes,
      mediaTypes,
      parentTypes,
      iconClassEnum,
      scanningText,
      isChecked,
      mediaIndicatorId,
      isMediaDisabled,
      isDisabledClick,
      handleClick,
      onDeleteMediaClick,
      ScanningStatusEnum,
    };
  },
};
